<template>
  <span>
    <DialogNormal
      v-model="inputedValue"
      :isFooter="true"
      :persistent="true"
      width="360"
    >
      <div class="pt-5 px-8">
        <div class="title font-weight-bold pb-3">
          {{ $t('user.user_authority-change') }}
        </div>

        <div class="executeButtonStyle">
          {{ $t('user.user_this-operation-cannot-be-undone') }}
        </div>
        <div>
          {{
            $t('user.user_do-you-really-want-to-change-this-member-authority')
          }}
        </div>
      </div>

      <template #footer>
        <v-spacer> </v-spacer>
        <NormalTextButton @click="onClickCancel" class="mr-2">
          <span class="cancelButtonStyle font-weight-bold">{{
            $t('user.user_cancel')
          }}</span>
        </NormalTextButton>
        <NormalTextButton @click="onClickChange" color="error">
          <span class="executeButtonStyle font-weight-bold">{{
            $t('user.user_do-change')
          }}</span>
        </NormalTextButton>
      </template>
    </DialogNormal>
  </span>
</template>

<script>
import DialogNormal from './DialogNormal'
import NormalTextButton from '@/components/items/Buttons/NormalTextButton'

export default {
  components: {
    DialogNormal,
    NormalTextButton
  },
  props: {
    value: {
      default: false
    }
  },
  methods: {
    onClickChange() {
      this.test = true
      this.$emit('change')
    },
    onClickCancel() {
      this.$emit('cancel')
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.value = newValue
        this.$emit('input', newValue)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.cancelButtonStyle {
  // color: #0095d9;
}
.executeButtonStyle {
  // color: #cd4444;
}
.title {
  font-size: 18px;
}
</style>
